<base-header
  [logo]="logo"
  [logoSmall]="logoSmall"
  [sections]="applicationSections"
  [userMenu]="userMenu"
  [isFullscreen]="isFullscreen"
></base-header>
<div class="d-flex justify-content-start">
  <base-sidebar
    class="d-xl-block d-none"
    [logo]="logo"
    [applicationSections]="applicationSections"
    *ngIf="!isFullscreen"
  ></base-sidebar>
  <section class="content">
    <router-outlet></router-outlet>
  </section>
</div>
